import React from 'react';
import {
  Heading,
  Toast,
  ToastType,
} from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { useEditMember } from './useMember';
import { Footer, GeneralInformation } from '../../components/AddEditMember';
import { withBreadcrumbs } from '../../components/Routing/Breadcrumbs';
import Roles from '../../components/Roles/Roles';
import useIframeAuth from '../hooks/useIframeAuth';
import {
  EDIT_MEMBER,
  FILL_FORM_TO_EDIT_MEMBER,
  MEMBER_SUCCESSFULLY_UPDATED,
  VIEW_MEMBER,
} from '../../utils/constants';
import {
  StyledListContainer,
  StyledTableHeader,
} from '../../components/CommonStyles/TableStyles';

const StyledBody = styled.div``;

export enum UserType {
  NEW = 'NEW',
  EXISTING = 'EXISTING',
  ORG_MEMBER = 'ORG_MEMBER',
}

interface Props {
  isOrgMember?: boolean;
}

const EditMember: React.FC<Props> = ({ isOrgMember = false }) => {
  const { userQuery, form, toast, userData, isViewOnlyRole } = useEditMember({
    isOrgMember,
  });

  const { loading } = userQuery;

  const {
    selectedRoles,
    password,
    confirmPassword,
    name,
    firstName,
    lastName,
    email,
    messageText,
    isEmailChanged,
    setIsEmailChanged,
    onRoleChange,
    setSelectedOrgs,
    onNameChange,
    onEmailChange,
    onCheckEmail,
    onFirstNameChange,
    onLastNameChange,
    onPassChange,
    onConfirmPassChange,
    onCancelClick,
    isFormInValid,
    onEditMember,
  } = form;

  const { showSuccessToast, setShowSuccessToast } = toast;

  const isSubmitDisabled =
    isFormInValid() ||
    isViewOnlyRole ||
    messageText.length > 0 ||
    isEmailChanged;
  const { isAuthorized } = useIframeAuth();

  const renderRolesUI = () => {
    return (
      <Roles
        setSelectedOrgs={setSelectedOrgs}
        selectedRoles={selectedRoles}
        setSelectedRoles={onRoleChange}
        isEdit={true}
        user={userData}
        isOrgMember={isOrgMember}
      />
    );
  };

  return (
    <StyledListContainer>
      <StyledTableHeader>
        <Heading variant="heading-medium">
          {isViewOnlyRole ? VIEW_MEMBER : EDIT_MEMBER}
        </Heading>
        {!isViewOnlyRole && (
          <Heading variant="heading-small" weight="light" color="primary.60">
            {FILL_FORM_TO_EDIT_MEMBER}
          </Heading>
        )}
      </StyledTableHeader>
      <StyledBody>
        {!loading && (
          <>
            <GeneralInformation
              isOrgMember={isOrgMember}
              isEdit={true}
              email={email}
              name={name}
              firstName={firstName}
              lastName={lastName}
              messageText={messageText}
              userType={UserType.NEW}
              isEmailChanged={isEmailChanged}
              setIsEmailChanged={setIsEmailChanged}
              onNameChange={onNameChange}
              onEmailChange={onEmailChange}
              onCheckEmail={onCheckEmail}
              onFirstNameChange={onFirstNameChange}
              onLastNameChange={onLastNameChange}
              onPassChange={onPassChange}
              onConfirmPassChange={onConfirmPassChange}
              password={password}
              confirmPass={confirmPassword}
            />
            {renderRolesUI()}
          </>
        )}
      </StyledBody>

      <Footer
        isEdit={true}
        hideEditButton={!isAuthorized('update:user')}
        disableSubmitButton={isSubmitDisabled}
        onEditMember={onEditMember}
        onCancel={onCancelClick}
      />

      <Toast
        data-testid="add-member-success-toast"
        isOpen={showSuccessToast}
        type={ToastType.SUCCESS}
        content={{ title: MEMBER_SUCCESSFULLY_UPDATED, description: '' }}
        autoHide={true}
        onHide={() => {
          setShowSuccessToast(false);
        }}
      />
      <div id="edit-member-toast" />
    </StyledListContainer>
  );
};

export default withBreadcrumbs(EditMember);
